import { useTranslation } from 'react-i18next';
import { FC, useMemo } from 'react';
import { useDiscoverDescV2 } from '../shared/use-discover-desc';
import { useDiscoverTitle } from '../shared/use-discover-title';
import { CommonPageTDK, DynamicHead } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { $Locale, $RootTraffic } from '@lemon8/web-app-shared/atom';

const DiscoverCanonical: FC = () => {
  const { enterHref: href } = useAtomValue($RootTraffic);
  const { region } = useAtomValue($Locale);

  const canonicalUrl = useMemo(() => {
    const u = new URL(href);
    return `https://${u.hostname}${u.pathname}?region=${region}`;
  }, [href]);

  return (
    <DynamicHead>
      <link rel="canonical" href={canonicalUrl} />
    </DynamicHead>
  );
};

class PageTDK extends CommonPageTDK {
  CanonicalLink = () => <DiscoverCanonical />;
}

export const DiscoverTDK: FC = () => {
  const { t } = useTranslation();

  const tdkInfo = {
    title: useDiscoverTitle(),
    description: useDiscoverDescV2(),
    keywords: t('keyword_default'),
  };

  return <PageTDK {...tdkInfo} />;
};
